/* AIVIQ collection pages (aiviq-coll-* sections). Add to cart, sliders and review videos come from
   aiviq-home.js; this file adds the parts only collection pages have:
   - "Læs mere" on the intro and the SEO block, "Se alle forskelle" on the comparison
   - filter dropdowns, the phone filter panel and the view switch (remembered in this browser)
   - the story card: slides rotate inside the card with a progress line and a pause button, and a
     tap opens them full screen. With reduced motion the card starts paused. */
(() => {
  if (window.AiviqCollection) return
  window.AiviqCollection = true

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  const desktop = window.matchMedia('(min-width: 990px)')
  const store = {
    get: (k) => { try { return localStorage.getItem(k) } catch (e) { return null } },
    set: (k, v) => { try { localStorage.setItem(k, v) } catch (e) {} }
  }
  // the site scrolls with Lenis; like the cart drawer, pause it while a panel or the story viewer is open
  const lockScroll = (on) => {
    document.documentElement.style.overflow = on ? 'hidden' : ''
    if (window.lenis) on ? window.lenis.stop() : window.lenis.start()
  }

  /* ---------- "Læs mere" on the intro ---------- */
  function initClamp(scope) {
    scope.querySelectorAll('[data-ac-clamp]').forEach((box) => {
      const btn = box.parentElement.querySelector('[data-ac-more]')
      if (!btn || btn.dataset.acBound) return
      btn.dataset.acBound = '1'
      const p = box.querySelector('p')
      const check = () => {
        if (box.classList.contains('is-open')) return
        btn.hidden = !(p && p.scrollHeight > p.clientHeight + 2)
      }
      check()
      window.addEventListener('resize', check, { passive: true })
      btn.addEventListener('click', () => {
        const open = !box.classList.contains('is-open')
        box.classList.toggle('is-open', open)
        btn.setAttribute('aria-expanded', open ? 'true' : 'false')
        const label = btn.querySelector('[data-ac-more-label]')
        if (label) {
          if (!label.dataset.more) label.dataset.more = label.textContent
          label.textContent = open ? label.dataset.less || label.dataset.more : label.dataset.more
        }
      })
    })
  }

  /* ---------- filters ---------- */
  function closeDropdowns(except) {
    document.querySelectorAll('.ac [data-ac-fd][open]').forEach((d) => { if (d !== except && !d.closest('.ac-tb__filters.is-open')) d.open = false })
  }

  function openPanel(panel) {
    const form = panel.closest('form')
    panel.classList.add('is-open')
    const scrim = document.createElement('div')
    scrim.className = 'ac-scrim'
    scrim.addEventListener('click', () => closePanel(panel))
    // the sticky toolbar is its own layer, so the scrim goes in there with the panel and the toolbar rises above the site header
    form.append(scrim)
    form.classList.add('is-panel')
    panel._scrim = scrim
    lockScroll(true)
    const first = panel.querySelector('button, input, summary, a')
    if (first) first.focus()
  }

  function closePanel(panel) {
    panel.classList.remove('is-open')
    if (panel._scrim) panel._scrim.remove()
    panel.closest('form').classList.remove('is-panel')
    lockScroll(false)
    const opener = panel.closest('form').querySelector('[data-ac-open-filters]')
    if (opener) opener.focus()
  }

  function initFilters(scope) {
    scope.querySelectorAll('[data-ac-filters]').forEach((form) => {
      if (form.dataset.acBound) return
      form.dataset.acBound = '1'
      // leave empty price fields out of the address
      form.addEventListener('submit', () => {
        form.querySelectorAll('input[type="number"]').forEach((i) => { if (i.value === '') i.disabled = true })
      })
      form.querySelectorAll('[data-ac-fd]').forEach((d) => {
        d.addEventListener('toggle', () => { if (d.open && desktop.matches) closeDropdowns(d) })
      })
    })
  }

  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-ac-open-filters]')
    if (open) {
      const panel = document.getElementById(open.getAttribute('aria-controls'))
      if (panel) openPanel(panel)
      return
    }
    const close = e.target.closest('[data-ac-close-filters]')
    if (close) { closePanel(close.closest('[data-ac-filter-panel]')); return }
    if (!e.target.closest('[data-ac-fd]')) closeDropdowns()

    const view = e.target.closest('[data-ac-view]')
    if (view) { setView(view.closest('[data-ac-products]'), view.dataset.acView, true); return }

    const model = e.target.closest('[data-ac-model]')
    if (model) { pickModel(model.closest('[data-ac-models]'), model); return }
    const modelReset = e.target.closest('[data-ac-model-reset]')
    if (modelReset) { pickModel(modelReset.closest('[data-ac-models]'), null); return }

    const cmp = e.target.closest('[data-ac-cmp-more]')
    if (cmp) {
      const sec = cmp.closest('[data-ac-cmp]')
      const all = !sec.classList.contains('is-all')
      sec.classList.toggle('is-all', all)
      cmp.setAttribute('aria-expanded', all ? 'true' : 'false')
      cmp.textContent = all ? 'Visa färre skillnader' : 'Se alla skillnader'
      return
    }
    const seo = e.target.closest('[data-ac-seo-more]')
    if (seo) {
      const sec = seo.closest('[data-ac-seo]')
      sec.classList.add('is-all')
      seo.remove()
      return
    }
    // "#nyhedsbrev" links go to the footer's signup form (its id depends on the theme)
    const news = e.target.closest('a[href="#nyhedsbrev"]')
    const form = news && document.querySelector('form[id^="newsletter-"]')
    if (form) {
      e.preventDefault()
      if (window.lenis) window.lenis.scrollTo(form, { offset: -window.innerHeight / 3 })
      else form.scrollIntoView({ behavior: 'smooth', block: 'center' })
      const input = form.querySelector('input[type="email"]')
      if (input) setTimeout(() => input.focus({ preventScroll: true }), 700)
    }
  })

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return
    const panel = document.querySelector('.ac-tb__filters.is-open')
    if (panel) { closePanel(panel); return }
    closeDropdowns()
  })

  /* ---------- machine picker (Tilbehør) ---------- */
  // Shows only the accessories whose data-fits names the machine; null (or a second tap) shows all again.
  function pickModel(wrap, btn) {
    if (!wrap) return
    const on = !!btn && btn.getAttribute('aria-pressed') !== 'true'
    wrap.querySelectorAll('[data-ac-model]').forEach((b) => b.setAttribute('aria-pressed', on && b === btn ? 'true' : 'false'))
    const sec = document.querySelector('[data-ac-products]')
    let n = 0
    if (sec) {
      sec.querySelectorAll('.ac-grid > .ac-pc').forEach((card) => {
        const show = !on || (card.dataset.fits || '').split(' ').includes(btn.dataset.acModel)
        card.classList.toggle('is-off', !show)
        if (show) n++
      })
      sec.classList.toggle('is-picked', on)
    }
    const st = wrap.querySelector('[data-ac-model-status]')
    if (!st) return
    st.hidden = !on
    const t = st.querySelector('[data-ac-model-text]')
    if (t && on) t.textContent = n ? `${n} passar ${btn.dataset.name}.` : `Inga tillbehör till ${btn.dataset.name} just nu.`
  }

  /* ---------- view switch ---------- */
  // Card photos follow the view, so a bigger card loads a sharper file ('small' matches the card snippet).
  const SHOT = {
    small: '(min-width: 1200px) 24vw, (min-width: 990px) 23vw, (min-width: 768px) 31vw, 46vw',
    big: '(min-width: 990px) 32vw, (min-width: 768px) 31vw, 46vw',
    list: '(min-width: 990px) 200px, 46vw',
    one: '(min-width: 990px) 24vw, 92vw'
  }
  function setView(sec, view, save) {
    if (!sec) return
    sec.dataset.view = view
    sec.querySelectorAll('.ac-pc__shot').forEach((img) => { if (SHOT[view] && img.getAttribute('sizes') !== SHOT[view]) img.setAttribute('sizes', SHOT[view]) })
    sec.querySelectorAll('.ac-pc__life source[data-f]').forEach((s) => {
      const f = s.dataset.f
      const v = view === 'big' ? `calc(32vw * ${f})` : `(min-width: 1200px) calc(24vw * ${f}), calc(23vw * ${f})`
      if (s.getAttribute('sizes') !== v) s.setAttribute('sizes', v)
    })
    sec.querySelectorAll('[data-ac-view]').forEach((b) => {
      const onDesktop = b.classList.contains('ac-d')
      const on = b.dataset.acView === view || (view === 'small' && b.dataset.acView === 'small')
      if ((onDesktop && desktop.matches) || (!onDesktop && !desktop.matches)) b.setAttribute('aria-pressed', on ? 'true' : 'false')
    })
    if (save) store.set(desktop.matches ? 'ac-view-d' : 'ac-view-m', view)
  }

  function initView(scope) {
    scope.querySelectorAll('[data-ac-products]').forEach((sec) => {
      const saved = store.get(desktop.matches ? 'ac-view-d' : 'ac-view-m')
      const ok = desktop.matches ? ['big', 'small', 'list'] : ['one', 'small']
      setView(sec, ok.includes(saved) ? saved : 'small', false)
    })
  }
  desktop.addEventListener('change', () => initView(document))

  /* ---------- stories ---------- */
  class Stories {
    constructor(root, slides, pg, pp, ms) {
      this.root = root
      this.slides = slides
      this.bars = pg ? [...pg.querySelectorAll('i')] : []
      this.pp = pp
      this.ms = ms
      this.i = 0
      this.t = 0
      this.paused = reduceMotion
      this.visible = true
      this.last = 0
      this.raf = 0
      if (pp) pp.setAttribute('aria-pressed', this.paused ? 'true' : 'false')
      this.show(0)
      this.loop = this.loop.bind(this)
      this.run()
    }
    // the frame loop only runs while the slides play on screen, so a paused or hidden card costs nothing
    run() {
      const go = !this.paused && this.visible && this.slides.length > 1
      if (go && !this.raf) { this.last = 0; this.raf = requestAnimationFrame(this.loop) }
      if (!go && this.raf) { cancelAnimationFrame(this.raf); this.raf = 0 }
    }
    setVisible(v) { this.visible = v; this.run(); this.media() }
    // a story with a film plays it while its slide is shown on screen; the others wait (always muted)
    media() {
      this.slides.forEach((s, k) => {
        const v = s.querySelector('video')
        if (!v) return
        if (k === this.i && this.visible && !this.paused) {
          if (v.preload === 'none') v.preload = 'auto'
          v.muted = true
          const p = v.play()
          if (p && p.catch) p.catch(() => {})
        } else v.pause()
      })
    }
    show(i) {
      const n = this.slides.length
      this.i = (i + n) % n
      this.t = 0
      this.slides.forEach((s, k) => {
        s.classList.toggle('is-active', k === this.i)
        const img = s.querySelector('img[loading="lazy"]')
        if (img && Math.abs(k - this.i) <= 1) img.loading = 'eager'
      })
      this.bars.forEach((b, k) => {
        b.classList.toggle('is-done', k < this.i)
        const fill = b.querySelector('b')
        if (fill) fill.style.width = k < this.i ? '100%' : '0%'
      })
      this.media()
    }
    loop(now) {
      const dt = this.last ? now - this.last : 0
      this.last = now
      this.t += dt
      const bar = this.bars[this.i] && this.bars[this.i].querySelector('b')
      if (bar) bar.style.width = `${Math.min(100, (this.t / this.ms) * 100)}%`
      if (this.t >= this.ms) this.show(this.i + 1)
      this.raf = requestAnimationFrame(this.loop)
    }
    toggle(force) {
      this.paused = typeof force === 'boolean' ? force : !this.paused
      if (this.pp) {
        this.pp.setAttribute('aria-pressed', this.paused ? 'true' : 'false')
        this.pp.setAttribute('aria-label', this.paused ? 'Spela upp berättelserna' : 'Pausa berättelserna')
      }
      this.run()
      this.media()
    }
    stop() { this.paused = true; this.run(); this.media() }
  }

  function initStories(scope) {
    scope.querySelectorAll('[data-ac-stories]').forEach((card) => {
      if (card.dataset.acBound) return
      card.dataset.acBound = '1'
      const ms = (Number(card.dataset.interval) || 5) * 1000
      const s = new Stories(card, [...card.querySelectorAll('[data-ac-slide]')], card.querySelector('.ac-pg'), card.querySelector('[data-ac-pp]'), ms)
      card._stories = s
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => { entries.forEach((en) => s.setVisible(en.isIntersecting)) }, { threshold: 0.35 }).observe(card)
      }
      card.querySelector('[data-ac-pp]').addEventListener('click', (e) => { e.stopPropagation(); s.toggle() })
      card.querySelector('[data-ac-open-stories]').addEventListener('click', () => openViewer(card))
    })
  }

  function openViewer(card) {
    const sec = card.closest('[data-ac-products]')
    const dlg = sec && sec.querySelector('[data-ac-viewer]')
    if (!dlg || typeof dlg.showModal !== 'function') return
    const stage = dlg.querySelector('[data-ac-sv-stage]')
    stage.innerHTML = ''
    lockScroll(true)
    dlg.showModal()
    // Photos fill the stage (object-fit: cover), so a wide one needs the stage height × its ratio in width.
    // The stage is measured open, before the slides go in, so each photo is fetched once at the right size.
    const box = stage.getBoundingClientRect()
    card.querySelectorAll('[data-ac-slide]').forEach((src) => {
      const s = src.cloneNode(true)
      s.removeAttribute('data-shopify-editor-block')
      const img = s.querySelector('img')
      if (img) {
        const ar = (Number(img.getAttribute('width')) / Number(img.getAttribute('height'))) || 1
        img.loading = 'eager'
        img.sizes = Math.ceil(Math.max(box.width, box.height * ar)) + 'px'
      }
      const x = s.querySelector('.ac-slide__x')
      if (x && x.dataset.full) x.textContent = x.dataset.full
      stage.append(s)
    })
    const cs = card._stories
    if (cs) cs.toggle(true)
    const pp = dlg.querySelector('[data-ac-sv-pp]')
    const v = new Stories(dlg, [...stage.children], dlg.querySelector('.ac-sv__pg'), pp, cs ? cs.ms : 5000)
    v.show(cs ? cs.i : 0)
    dlg._stories = v
    if (!dlg.dataset.acBound) {
      dlg.dataset.acBound = '1'
      dlg.querySelector('[data-ac-sv-close]').addEventListener('click', () => dlg.close())
      dlg.querySelector('[data-ac-sv-pp]').addEventListener('click', () => dlg._stories && dlg._stories.toggle())
      dlg.querySelectorAll('[data-ac-sv-dir]').forEach((b) => b.addEventListener('click', () => {
        const st = dlg._stories
        if (!st) return
        if (Number(b.dataset.acSvDir) > 0 && st.i === st.slides.length - 1) { dlg.close(); return }
        st.show(st.i + Number(b.dataset.acSvDir))
      }))
      dlg.addEventListener('keydown', (e) => {
        const st = dlg._stories
        if (!st) return
        if (e.key === 'ArrowRight') st.show(st.i + 1)
        if (e.key === 'ArrowLeft') st.show(st.i - 1)
      })
      dlg.addEventListener('close', () => {
        if (dlg._stories) { dlg._stories.stop(); dlg._stories = null }
        dlg.querySelectorAll('video').forEach((v) => v.pause())
        const c = dlg.closest('[data-ac-products]').querySelector('[data-ac-stories]')
        if (c && c._stories && !reduceMotion) c._stories.toggle(false)
        lockScroll(false)
      })
    }
  }

  /* ---------- start ---------- */
  function init(scope) {
    initClamp(scope)
    initFilters(scope)
    initView(scope)
    initStories(scope)
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document))
  else init(document)
  document.addEventListener('shopify:section:load', (e) => init(e.target))
})()
